module.exports = __webpack_public_path__ + "img/fail.7af2af18.svg";